export default __webpack_public_path__ + "static/poster-a6f36b0464457d6813b961ecc26adc53.png";